import { __awaiter, __generator } from "tslib";
import { Destination } from './destination';
export { Destination };
export function createDestination(name, settings) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (name) {
                case 'gtag':
                    return [2 /*return*/, import(/* webpackChunkName: "gtag" */ './gtag').then(function (mod) {
                            return mod.default(settings);
                        })];
                case 'Google Tag Manager':
                    return [2 /*return*/, import(
                        /* webpackChunkName: "google-tag-manager" */ './google-tag-manager').then(function (mod) { return mod.default(settings); })];
                default:
                    return [2 /*return*/, undefined];
            }
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=index.js.map